module.exports = __webpack_public_path__ + "static/media/sliderbg.2a5786d2.png";